import { render, staticRenderFns } from "./inicio_en.vue?vue&type=template&id=484c7cbe&"
import script from "./inicio_en.vue?vue&type=script&lang=js&"
export * from "./inicio_en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports